import React from "react";
import {MenuItem} from "@mui/material";
import ModuleLoader from "../module-loader";

const ModuleMenuItemPlaceholder = ({id, component, fallback, ...props}) => (
  <ModuleLoader
    id={id}
    component={component}
    fallback={
      // the width of this component is used by Material-UI to position the Menu in ButtonSelect
      <MenuItem>{fallback}</MenuItem>
    }
    {...props}
  />
);

export default ModuleMenuItemPlaceholder;
